import styled from 'styled-components';

export const Section = styled.section<{ variant?: 'default' | 'card' }>`
  ${({ variant = 'default', theme }) => {
    if (variant === 'card') {
      return `
        background: ${theme.colors.background};
        padding: ${theme.spacing.lg};
        border-radius: ${theme.borderRadius.lg};
        box-shadow: ${theme.shadows.sm};
      `;
    }
    return '';
  }}
`;

export const SectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;
